import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getSavedBills = () => {
  return axiosPrivate.get(`/bills/api/v1/saved-bills/`)
}